exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-image img[data-v-1106c7bd]{max-width:100%!important}", ""]);

// exports
